import { useQueryState } from "context/queryState"

import { API_MAPPING, changeModalState } from "reducers/api-mappings/api-mapping-actions"
import styled from "styled-components"

import ApiApiMappings from "api/ApiApiMappings"
import ApiMappingList from "./components/apiMappingList"
import { DeleteEndpoints } from "./components/modalDelete"
import { useAppDispatch, useAppSelector } from "reducers/store"
import { useCallback, useState } from "react"
import { ApiMappingHeader } from "./components/apiMappingHeader"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 48px 0;
`

const initialFilters: App.ApiMappingFilters = {
  product: undefined
}

const ApiMapping = () => {
  const appDispatch = useAppDispatch()

  const [filters, setFilters] = useState<App.ApiMappingFilters>(initialFilters)

  useQueryState(
    [API_MAPPING, filters],
    async () => await new ApiApiMappings().getAll({ productIds: filters.product }),
    API_MAPPING,
    {
      refetchOnMount: true
    }
  )

  const [showDeletionModal, setShowDeletionModal] = useState<App.ApiMapping>()

  const { data } = useAppSelector((state) => state.apiMapping.apiMappingList)

  const handleOpenDeletionModal = useCallback(
    (index: number) => {
      setShowDeletionModal(data[index])
      appDispatch(changeModalState(true, "delete"))
    },
    [data]
  )

  return (
    <Container>
      <ContentContainer>
        <ApiMappingHeader data={data} filters={filters} setFilters={setFilters} initialFilters={initialFilters} />
        <ApiMappingList openModal={handleOpenDeletionModal} />
        <DeleteEndpoints endpointData={showDeletionModal} />
      </ContentContainer>
    </Container>
  )
}

export default ApiMapping
